import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/gerar-documento`;
export const createGerarDocumento = async (formBuilder) => {
  return await axios.post(`${httpUrl}/create`, formBuilder).then((response) => response);
};

export const getGerarDocByIdRegistroAtendimento = async (idRegistroAtendimento) => {
  return await axios.get(`${httpUrl}/registro-atendimento/${idRegistroAtendimento}`).then((response) => response);
};

export const getGerarDocByIdPaciente = async (idPaciente) => {
  return await axios.get(`${httpUrl}/paciente/${idPaciente}`).then((response) => response);
};

export const visualizarDocumentoPorId = async (id) => {
  return await axios
    .get(`${httpUrl}/download-documento/${id}`, {
      responseType: 'blob',
    })
    .then((response) => response);
};

export const deletarDocumento = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};
